// extracted by mini-css-extract-plugin
export var active = "_2z-9";
export var backButton = "_2z-8";
export var clone = "_2z-e";
export var collapseBar = "_2z-k";
export var collapseMode = "_2z-m";
export var collapsed = "_2z-o";
export var dimmed = "_2z-i";
export var dragHandle = "_2z-c";
export var dropdownIcon = "_2z-g";
export var expanding = "_2z-n";
export var hidden = "_2z-x";
export var iconContainer = "_2z-q";
export var iconSwapper = "_2z-w";
export var navItem = "_2z-6";
export var navItemIcon = "_2z-f";
export var navProfile = "_2z-7";
export var notificationCountBadge = "_2z-j";
export var notificationDot = "_2z-r";
export var optionsContainer = "_2z-h";
export var primaryNav = "_2z-0";
export var primaryNavDivider = "_2z-v";
export var primaryNavResizeHandle = "_2z-2";
export var primaryNavResizing = "_2z-1";
export var primaryNavTabSection = "_2z-u";
export var primaryTab = "_2z-p";
export var primaryTabIconBox = "_2z-s";
export var secondaryNav = "_2z-3";
export var selected = "_2z-t";
export var settingsNav = "_2z-4";
export var settingsNavItems = "_2z-5";
export var show = "_2z-d";
export var sideNav = "_2z-l";
export var teamItem = "_2z-a";
export var userProfileItem = "_2z-b";